<template>
    <div
        class="planBadge"
        :class="[
            `planBadge--${plan}`,
            `planBadge--${size}`,
            { 'planBadge--withIcon': showIcon }
        ]"
        :style="customStyle"
    >
        <sw-icon
            v-if="showIcon"
            :name="plan === PLAN_TYPES.ENTERPRISE ? 'trophy' : 'star-full'"
            class="planBadge_icon"
        />
        <span class="planBadge_text">{{ planText }}</span>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { PLAN_TYPES, PLAN_BADGE_SIZES, PLAN_CONFIG } from '@/constants';

    const props = defineProps({
        plan: {
            type: String,
            required: true,
            validator: (value) => Object.values(PLAN_TYPES).includes(value)
        },
        size: {
            type: String,
            default: PLAN_BADGE_SIZES.MEDIUM,
            validator: (value) => Object.values(PLAN_BADGE_SIZES).includes(value)
        },
        showIcon: {
            type: Boolean,
            default: true
        },
        customColor: {
            type: String,
            default: null
        }
    });

    // Usando configuração das constantes

    const planText = computed(() => {
        return PLAN_CONFIG[props.plan]?.name || 'Gratuito';
    });

    const customStyle = computed(() => {
        const color = props.customColor || PLAN_CONFIG[props.plan]?.color || '#6b7280';
        return {
            backgroundColor: color
        };
    });
</script>

<style lang="scss" scoped>
.planBadge {
    display: inline-flex;
    align-items: center;
    gap: 0.5em;
    font-size: 0.8em;
    font-weight: 700;
    color: white;
    padding: 5px 10px;
    border-radius: 1em;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    line-height: 1;
    text-align: center;
    cursor: default;
}

/* ===========================
   TAMANHOS (SIMPLIFICADOS)
   =========================== */
.planBadge--small {
    font-size: 0.7em;
    padding: 4px 8px;
}

.planBadge--medium {
    font-size: 0.8em;
    padding: 5px 10px;
}

.planBadge--large {
    font-size: 0.9em;
    padding: 6px 12px;
}

/* ===========================
   ELEMENTOS
   =========================== */
.planBadge_icon {
    font-size: 0.875em;
    opacity: 0.9;
}

.planBadge_text {
    font-weight: inherit;
    letter-spacing: inherit;
}

/* ===========================
   ESTILO ESPECIAL EMPRESARIAL
   =========================== */
.planBadge--enterprise {
    background: linear-gradient(135deg, #f59e0b, #d97706) !important;
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
        transition: left 0.6s ease;
    }

    &:hover {
        box-shadow: 0 6px 16px rgba(245, 158, 11, 0.4);
        transform: translateY(-1px);

        &::before {
            left: 100%;
        }

        .planBadge_icon {
            transform: scale(1.1);
            filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.5));
        }
    }

    .planBadge_icon {
        transition: all 0.3s ease;
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
    }
}

/* ===========================
   VARIAÇÕES SEM ÍCONE
   =========================== */
.planBadge:not(.planBadge--withIcon) {
    gap: 0;
}
</style>